<div class="">
    <h3 class="p-2 mb-2 bg-dark text-light">Recent News</h3>
    
    
    <div class="news-block">
       
        <div class="news-date">
            29<sup>th</sup> July, 2026
        </div>
        <div class="news-text">
            Excited to share that I’ve been selected to participate in the 2026 CeMENT workshop, a peer mentoring program for junior faculty. Looking forward to joining everyone in Chicago!
        </div>
        <hr>
    </div>

    <div class="news-block">
       
        <div class="news-date">
            12<sup>th</sup> June, 2026
        </div>
        <div class="news-text">
            Excited to share that my PhD dissertation chapter (job market paper) is now forthcoming in the Journal of Public Economics!
        </div>
        <hr>
    </div>

    <div class="news-block">
       
        <div class="news-date">
            10<sup>th</sup> October, 2025
        </div>
        <div class="news-text">
            Received 2025 National Tax Association (NTA) Equity and Inclusion Fellowship
        </div>
        <hr>
    </div>

    <div class="news-block">
       
        <div class="news-date">
            14<sup>th</sup> October, 2024
        </div>
        <div class="news-text">
            Honored to receive the 2024 JSIT Research Award Winner. I will be working on Understanding Supplemental Security Income (SSI) among Formerly Incarcerated Individuals with Disabilities.
        </div>

        <div class="news-text">
            <a href="https://rdrc.wisc.edu/project/jsit24-05" target="_blank" class="btn badge badge-primary news-buttons">Abstract</a> 
            <!-- <a href="../../../assets/proposal/Dissertation_Proposal_Ankit_Agrawal_Final.pdf" target="_blank" class="btn badge badge-primary news-buttons">Document</a> -->
            
        </div>
        <hr>
    </div>

    <div class="news-block">
       
        <div class="news-date">
            August, 2024
        </div>
        <div class="news-text">
            Appeared in PhD spotlight of University of Illinois
            
        </div>
        <div class="news-text">
            <a href="https://emails.illinois.edu/newsletter/38/2106627938.html" target="_blank" class="btn badge badge-primary news-buttons">Read More</a> 
            <!-- <a href="../../../assets/proposal/Dissertation_Proposal_Ankit_Agrawal_Final.pdf" target="_blank" class="btn badge badge-primary news-buttons">Document</a> -->
            
        </div>

        <hr>
    </div>
    
    <div class="news-block">
       
        <div class="news-date">
            10<sup>th</sup> June, 2024
        </div>
        <div class="news-text">
            Participated in Summer workshop and mentoring program JSIT 2024 Junior Scholars at the UW-RDRC at the University of Wisconsin–Madison
            <!-- <a href="" target="_blank">https://rdrc.wisc.edu/2024-jsit-scholars.html</a> -->

        </div>

        <div class="news-text">
            <a href="https://rdrc.wisc.edu/2024-jsit-scholars.html" target="_blank" class="btn badge badge-primary news-buttons">2024 JSIT Scholars List</a> 
            <!-- <a href="../../../assets/proposal/Dissertation_Proposal_Ankit_Agrawal_Final.pdf" target="_blank" class="btn badge badge-primary news-buttons">Document</a> -->
            
        </div>
        <hr>
    </div>
    
   

    


    <div class="news-block">
       
        <div class="news-date">
            28<sup>th</sup> Mar, 2024
        </div>
        <div class="news-text">
            Defended my dissertation titled "Three Essays on Labor Economics and Public Policy"
        </div>
        <hr>
    </div>

   

</div>